export interface Cluster {
  id?: string;
  maxCurrent: number;
  minCurrent: number;
  number: number;
  alias?: string;
  phaseAssignment: string;
  sockets?: Socket[];
}

export interface Socket {
  socketSerialNumber: string;
  socketNumber: number;
  socketPhaseUsed: string;
  socketMaxPhases: number;
  failsafeCurrent: number;
}
